(function() {
    
    angular.module('ngmvac').
        directive('cardPayment', function() {
            return {
                restrict: 'A',                
                link: function(scope, element, attrs){
                    console.log(element);
                    element.card({
                        container: '#card-container', 
                        width: 200,
                    });
                }
            };
        });
    
    })();